import React, { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * Authenticated <img> via fetch-as-blob.
 * `src` should be the relative API url (e.g. /api/files/...).
 */
export default function AuthImage({ src, alt = "", className = "", testId }) {
    const [blobUrl, setBlobUrl] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!src) return;
        let revoke = null;
        let cancel = false;
        (async () => {
            try {
                // src already starts with /api/...
                const path = src.replace(/^\/api/, "");
                const resp = await api.get(path, { responseType: "blob" });
                if (cancel) return;
                const url = URL.createObjectURL(resp.data);
                revoke = url;
                setBlobUrl(url);
            } catch {
                if (!cancel) setError(true);
            }
        })();
        return () => {
            cancel = true;
            if (revoke) URL.revokeObjectURL(revoke);
        };
    }, [src]);

    if (error || !src) return null;
    if (!blobUrl) {
        return <div className={`${className} bg-stone-100 animate-pulse`} data-testid={testId ? `${testId}-loading` : undefined} />;
    }
    return <img src={blobUrl} alt={alt} className={className} data-testid={testId} />;
}
